import { scan } from 'react-scan'; // must be imported before React and React DOM
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

import { initI18n } from '@/i18n/i18n.ts';
scan({
  enabled: import.meta.env.VITE_REACT_SCAN === 'true',
});

initI18n()
  .then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((error) => {
    console.error('Failed to initialize i18n', error);
  });
